export const formatCurrency = (value?: string) => {
  if (!value) {
    return ''
  }
  const converted = value
    .normalize('NFKC') // 全角文字を半角に正規化
    .replace(/[−ー]/, '-') // 半角ハイフンに置換（念のため）
    .replace(/^0+(?!\.|$)/, '') // 接頭の0埋めを削除

  const nonNumericRegExp = /[^0-9.-]/g

  const numeric = converted.replace(nonNumericRegExp, '') // 非数値・ドット・ハイフンを削除
  const [integerPart, decimalPart] = numeric.split('.')
  const commaed = integerPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') // 3桁ごとにカンマ挿入
  if (!decimalPart) {
    return commaed
  }
  const excludedEndZero = decimalPart.replace(/0+$/, '')
  if (excludedEndZero.length === 0) {
    return commaed
  }
  return [commaed, excludedEndZero].join('.')
}
